import { useTranslation } from "react-i18next"
import { Stack, Tooltip, Typography } from "@mui/material"
import TimelineIcon from "@mui/icons-material/Timeline"
import QueryStatsIcon from "@mui/icons-material/QueryStats"

interface PlotDataProcessingTooltipProps {
  isRawData?: boolean
  aggregate?: string[]
}

const PlotDataProcessingTooltip = ({
  isRawData,
  aggregate,
}: PlotDataProcessingTooltipProps) => {
  const { t } = useTranslation()

  if (isRawData) {
    return (
      <Tooltip
        title={t("plot_legends.RAW_DATA_TOOLTIP")}
        enterTouchDelay={0}
        placement="bottom-start"
        arrow
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          color="neutral.600"
          width="fit-content"
        >
          <QueryStatsIcon sx={{ fontSize: 12, display: "block" }} />
          <Typography
            variant="body1"
            color="neutral.600"
            sx={{ lineHeight: 1, fontSize: 10, fontWeight: 500 }}
          >
            {t("plot_legends.RAW_DATA")}
          </Typography>
        </Stack>
      </Tooltip>
    )
  }

  if (aggregate && aggregate.length > 0) {
    const translatedAggregate = aggregate
      .map((a) => t(`plots_tooltip.${a.toUpperCase()}`))
      .join(", ")

    const content = (
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        color="neutral.600"
        width="fit-content"
      >
        <TimelineIcon sx={{ fontSize: 12, display: "block" }} />
        <Typography
          variant="body1"
          color="neutral.600"
          sx={{ lineHeight: 1, fontSize: 10, fontWeight: 500 }}
        >
          {t("plot_legends.AGGREGATED_DATA", { aggregate: translatedAggregate })}
        </Typography>
      </Stack>
    )

    return (
      <Tooltip
        title={t("plot_legends.AGGREGATED_DATA_TOOLTIP", {
          aggregate: translatedAggregate,
        })}
        enterTouchDelay={0}
        placement="bottom-start"
        arrow
      >
        {content}
      </Tooltip>
    )
  }

  return null
}

export default PlotDataProcessingTooltip
